module.exports = __webpack_public_path__ + "img/claim-notice.51f3a33e.jpeg";